module.exports = __webpack_public_path__ + "img/browser_samsung.19d8f992.svg";